module.exports = __webpack_public_path__ + "static/media/shape-back.9c0594f2.svg";